import { eventService, levelService } from "@/services/axios";
import Role from '@/utils/role'

export default {
  async getLevels({ commit }) {
    return await levelService.all().then(({data}) => {
      commit('setLevels', data)
    })
  },
  async getUserEvents({ commit, state }) {
    let role = Role.fromRole(`${state.role}`);
    return await eventService.getEvents(state.institution.institution_id, state.user.id, role.id).then(({data}) => {
      commit('setEvents', data.data)
    })
  },
  async getModuleEvents({ commit, state }) {
    let role = Role.fromRole(`${state.role}`);
    return await eventService.getModuleEvents(state.user.id, role.id, state.navigation.currentModule.module_id).then(({data}) => {
      commit('setEvents', data)
    })
  },
  async getUnitEvents({ commit, state }) {
    return await eventService.getUnitEvents(state.user.id, state.navigation.currentLesson.unit_id).then(({data}) => {
      commit('setEvents', data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js